<template>
  <div class="row resource-details">
    <div class="col-md-8 mx-auto">
      <div v-if="resource.content_type === 'video'" class="mb-3">
        <iframe-video :src="resource.content"></iframe-video>
      </div>
      <div class="text-center mb-3 overflow-auto" style="height: 240px" v-else>
        <img
          :src="resource.content"
          alt=""
          class="resource-details__video"
          style="width: 100%"
        />
      </div>

      <h2 id="framework" v-text="item.title"></h2>
      <p v-html="item.long_description"></p>

      <form
        :action="resource.file_url"
        method="GET"
        v-if="resource.content_type === 'file'"
      >
        <button class="btn wfh-btn-primary mb-5" type="submit">
          Download Now
        </button>
      </form>
      <!-- <div class="row">
        <div class="col-md-12 text-justify">
          <p>
            Workingfromhome.io is an initiative by TribeHired to help companies
            share how they are prioritising employees' well-being while
            maintaining efficient day-to-day operations during the Covid-19
            crisis.
          </p>

          <p>
            We are building out tools to give you a framework for the best
            measures to take for WFH.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center" id="downloadButtonsRow">
          <div
            class="spinner-border text-secondary"
            role="status"
            v-if="loading"
          >
            <span class="sr-only">Loading...</span>
          </div>



          <button
            class="btn btn-primary"
            v-if="disabled"
            :disabled="disabled"
            v-text="downloadBtnText()"
          ></button>

          <div v-if="disabled" class="alert alert-success mt-4" role="alert">
            Download Successful!
            <br />
            Hey, let’s add your company to list of awesome companies by sharing
            with the community on how you’re going remote.
            <br />
            <a href="/company/create">Add Your Company</a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["resource"],

  data() {
    return {
      item: this.resource,
      pdfBlob: null,
      disabled: false,
      loading: true,
    }
  },

  computed: {
    videoUrl() {
      return this.resource.content
    },

    blobUrl() {
      return window.URL.createObjectURL(this.pdfBlob)
    },

    blobFileName() {
      return this.item.file_name
    },

    async handleDownload() {
      this.disabled = true

      const response = await axios
        .post("/resource/download/" + this.resource.id + "/counter")
        .then((data) => data.data.data)
    },
  },

  methods: {
    async getPdfBlob() {
      this.pdfBlob = await axios
        .get("/resource/download/" + this.item.id, { responseType: "blob" })
        .then((data) => data.data)

      this.loading = false
    },

    downloadBtnText() {
      return "Download " + this.item.title
    },
  },

  mounted() {
    if (resource.content_type === 1) {
      this.getPdfBlob()
    }
  },
};
</script>

<style lang="scss" scoped>
.resource-details {
  margin-top: 72px;
  padding-top: 40px;

  &__video {
    margin-bottom: 30px;
  }
}
</style>
